import { useBackend } from "../../services";

export const useConfirmSpreadsheetImport = () => {
  const { patch } = useBackend();
  return async () => {
    return await patch("xlsx/import");
  };
};
